module.exports = __webpack_public_path__ + "img/fachada_direction_2_format_1.0d52b588.jpg";